import React, { useMemo } from 'react';
import ReactJson from 'react-json-view';
import usePersistedState from 'shared/hooks/usePersistedState';
import { PersistedStateKeys } from '../../../shared/enums';

interface IDevModeDisplayJSONProps {
  src: Record<string, unknown> | undefined;
  expanded?: boolean;
}

const getTypeName = (src: Record<string, unknown> | undefined): string | undefined => {
  if (src) {
    if (src.__typename) {
      return `${src.__typename}`;
    } else {
      for (const key in src) {
        if (typeof src[key] === 'object' && src[key] !== null) {
          return getTypeName(src[key] as Record<string, unknown> | undefined);
        }
      }
      return 'Unknown';
    }
  }
  return 'undefined';
};

const DevModeDisplayJSON = ({ src, expanded }: IDevModeDisplayJSONProps): JSX.Element => {
  const [isDeveloperModeEnabled] = usePersistedState(PersistedStateKeys.IsDeveloperModeEnabled, false);

  const typeName = useMemo(() => {
    return getTypeName(src);
  }, [src]);

  return isDeveloperModeEnabled ? (
    <ReactJson style={{ fontSize: 14 }} sortKeys collapsed={!expanded} name={typeName} src={src || {}} />
  ) : (
    <></>
  );
};

export default DevModeDisplayJSON;
